import { useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { LOGIN_ROUTE } from '../Router';
import reactPress from '../reactpress';
import { useSearchParams } from 'react-router-dom';

interface Props {
  element: JSX.Element;
}

const Authenticated = ({ element }: Props): JSX.Element => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const isNotAuthenticated = useCallback(() => !reactPress?.user?.ID, []);

  useEffect(() => {
    if (isNotAuthenticated()) {
      window.location.href = LOGIN_ROUTE;
      return;
    }
  }, [searchParams, isNotAuthenticated]);

  return isNotAuthenticated() ? (
    <div className="tw-flex tw-w-full tw-justify-center">
      <span>{t('redirect')}</span>
    </div>
  ) : (
    element
  );
};

export default Authenticated;
